// extracted by mini-css-extract-plugin
export default {"container":"Page404_container__GWrbO","content":"Page404_content__WN3RQ","title":"Page404_title__Eye3L","message":"Page404_message__I8mS1","link":"Page404_link__CNIxU"};